import { ApiQueryParams } from '@frontend/api-utils';
import { useAppSelector } from '@frontend/common';
import { ListInfo, listStore } from '@frontend/repository';
import { useSelector } from 'react-redux';
import { FilterModalProps } from './filter-modal.component';

interface ViewProps {
    params?: ApiQueryParams<string | number>;
}

const useFilterModal = <T extends object & { id: string }>(props: FilterModalProps<T>): ViewProps => {
    const store = useAppSelector(useSelector, listStore);
    const list: ListInfo | undefined = store[props.listId];

    return { params: list?.filter };
};

export default useFilterModal;
